import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import StakeholderCell from '../../../components/admin/StakeholderCell';
import plusImg from '../../../assets/images/plus.svg';
import questionImg from '../../../assets/images/question.svg';
import closeImg from '../../../assets/images/close.svg';
import {
  createStakeholder,
  updateStakeholder,
  deleteStakeholder,
} from '../../../actions/stakeholder';
import { deleteConnections } from '../../../actions/connection';

const StakeHolders = ({ stakeholders, connections }) => {
  const dispatch = useDispatch();

  const project = useSelector((state) => state.project.project);
  const [selected, setSelected] = useState('');
  const [isShowAddStakeholderModal, setShowAddStakeholderModal] = useState(false);
  const [isShowEditStakeholderModal, setShowEditStakeholderModal] = useState(false);
  const [isShowDeleteStakeholderModal, setShowDeleteStakeholderModal] = useState(false);
  const [newStackholderName, setNewStackholderName] = useState('');
  const [editStackholderName, setEditStackholderName] = useState('');

  const handleAddStakeholder = () => {
    if (!newStackholderName) return;
    if (project) {
      dispatch(
        createStakeholder({
          projectId: project.id,
          name: newStackholderName,
          createdAt: new Date(),
        }),
      );
    }
    setShowAddStakeholderModal(false);
    setNewStackholderName('');
  };

  const handleEditStakeholder = () => {
    if (!editStackholderName) return;
    dispatch(
      updateStakeholder({
        ...selected,
        name: editStackholderName,
        updatedAt: new Date(),
      }),
    );
    setShowEditStakeholderModal(false);
  };

  const handleDeleteStakeholder = () => {
    dispatch(deleteStakeholder(selected.id));
    let filteredConnectionIds = connections
      .filter((c) => {
        return c.from === selected.id || c.to === selected.id;
      })
      .map((c) => c.id);
    dispatch(deleteConnections(filteredConnectionIds));
    setShowDeleteStakeholderModal(false);
  };

  const renderTooltip = (props) => (
    <Tooltip id="custom-tooltip" {...props}>
      <div className="custom-tooltip">
        <div className="tooltip-header">Stakeholder</div>
        <div className="tooltip-content">
          Here is where you can add and manage Stakeholders. These become ovals in the web.
        </div>
      </div>
    </Tooltip>
  );

  return (
    <>
      <div className="stake-section">
        <div className="stake-section-header">
          <div className="text-section">
            <p>Stakeholder</p>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <img src={questionImg} alt="quiz" />
            </OverlayTrigger>
          </div>
          <button
            className="primary-btn"
            disabled={project === ''}
            onClick={() => setShowAddStakeholderModal(true)}
          >
            <img src={plusImg} alt="plus" /> Add Stakeholder
          </button>
        </div>
        <div className="stake-list">
          <div className="stake-item-header">
            <div className="main-section">
              <p>#</p>
              <div>Stakeholder Name</div>
            </div>
          </div>
          {stakeholders.map((stakeholder, index) => (
            <StakeholderCell
              stakeholder={stakeholder}
              key={stakeholder.id}
              index={index + 1}
              setShowDeleteStakeholderModal={setShowDeleteStakeholderModal}
              setShowEditStakeholderModal={setShowEditStakeholderModal}
              setSelected={setSelected}
              setEditStackholderName={setEditStackholderName}
            />
          ))}
        </div>
      </div>
      {isShowAddStakeholderModal && (
        <div className="custom-modal">
          <div className="modal-card">
            <img
              src={closeImg}
              alt=""
              className="close-btn"
              onClick={() => setShowAddStakeholderModal(false)}
            />
            <div className="modal-card-inner">
              <h1 className="title">Add Stakeholder</h1>
              <div className="form-item">
                <label htmlFor="type">Name for the Stakeholder</label>
                <input
                  type="text"
                  placeholder="Type your stakeholder name"
                  value={newStackholderName}
                  onChange={(e) => setNewStackholderName(e.target.value)}
                />
              </div>
              <button className="primary-btn solo-btn" onClick={handleAddStakeholder}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {isShowEditStakeholderModal && (
        <div className="custom-modal">
          <div className="modal-card">
            <img
              src={closeImg}
              alt=""
              className="close-btn"
              onClick={() => setShowEditStakeholderModal(false)}
            />
            <div className="modal-card-inner">
              <h1 className="title">Edit Stakeholder</h1>
              <div className="form-item">
                <label htmlFor="type">Name for the Stakeholder</label>
                <input
                  type="text"
                  placeholder="Type your stakeholder name"
                  value={editStackholderName}
                  onChange={(e) => setEditStackholderName(e.target.value)}
                />
              </div>
              <button className="primary-btn solo-btn" onClick={handleEditStakeholder}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}
      {isShowDeleteStakeholderModal && (
        <div className="custom-modal">
          <div className="modal-card">
            <img
              src={closeImg}
              alt=""
              className="close-btn"
              onClick={() => setShowDeleteStakeholderModal(false)}
            />
            <div className="modal-card-inner">
              <h1 className="title">Are you sure, that you want to delete {selected.name} ?</h1>
              <div className="modal-actions">
                <button className="primary-btn" onClick={handleDeleteStakeholder}>
                  Yes
                </button>
                <button
                  className="outline-btn"
                  onClick={() => setShowDeleteStakeholderModal(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StakeHolders;
